export default navigator.mediaDevices ?
  // navigator.mediaDevices.getUserMedia :
  (arg, successCallback, errorCallback) => (
    navigator.mediaDevices.getUserMedia(arg).then(successCallback).catch(errorCallback)
  ) :
  (navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia);



// WEBPACK FOOTER //
// ./src/utils/react-audio-recorder-fixed/getUserMedia.js